// 第一步：所有 import 保留在文件最顶层（满足 ESM 语法要求，不可嵌套）
import "animate.css";
import "@/css/global.css";
import "swiper/css";
import "@/js/i18n.js";
import Swiper from "swiper";
import { WOW } from "wowjs";

// 第二步：定义全局唯一标记（挂载到 window，防止重复执行）
const JS_FILE_EXECUTED_MARK = "jsFileHasExecuted_global";

// 第三步：包裹所有可执行逻辑（非 import/export 的代码都放在这里）
if (!window[JS_FILE_EXECUTED_MARK]) {
  console.log(window[JS_FILE_EXECUTED_MARK], "window[JS_FILE_EXECUTED_MARK]");
  // 标记为已执行，阻止后续重复引入时执行逻辑
  window[JS_FILE_EXECUTED_MARK] = true;

  /*--------------------------WOW.js--------------------------------*/
  new WOW({ live: false }).init();
  /*------------------------折叠栏----------------------------------*/
  var sliderNav = document.querySelector(".slider-nav");
  var sliderButton = document.querySelector(".slider-button");
  function changeSliderNav(e) {
    if (sliderNav.classList.contains("open")) {
      sliderNav.classList.remove("open");
    } else {
      sliderNav.classList.add("open");
    }
    if (sliderButton.classList.contains("active")) {
      sliderButton.classList.remove("active");
    } else {
      sliderButton.classList.add("active");
    }
  }
  sliderButton
    ? (sliderButton.onclick = function () {
        changeSliderNav();
      })
    : "";

  var sliderLi = document.querySelectorAll(".slider-nav>li div");
  for (let i = 0; i < sliderLi.length; i++) {
    sliderLi[i].onclick = function () {
      if (sliderButton.classList.contains("active")) {
        sliderButton.classList.remove("active");
      } else {
        sliderButton.classList.add("active");
      }
      if (sliderNav.classList.contains("open")) {
        sliderNav.classList.remove("open");
      } else {
        sliderNav.classList.add("open");
      }
      for (var j = 0; j < sliderLi.length; j++) {
        if (sliderLi[j].classList.contains("active-link")) {
          sliderLi[j].classList.remove("active-link");
        }
      }
      if (this.classList.contains("active-link")) {
        this.classList.remove("active-link");
      } else {
        this.classList.add("active-link");
      }
    };
  }

  function getNormalizedLanguage() {
    const storedLanguage = localStorage.getItem("preferred-language");
    return storedLanguage === "null" || storedLanguage === null
      ? "zh-CN"
      : storedLanguage;
  }

  // 工具函数：根据语言代码获取显示文本
  function getLanguageDisplayText(lang) {
    const languageMap = {
      en: "English",
      zh: "繁體中文",
      "zh-CN": "简体中文",
    };
    return languageMap[lang] || "简体中文";
  }

  function updateLanguageDisplay(language) {
    const displayText = getLanguageDisplayText(language);

    const updateElement = (selector) => {
      const element = document.querySelector(selector);
      if (element) element.innerText = displayText;
    };

    updateElement(".normal .preferred-language");
    updateElement(".mini .preferred-language");
  }

  function applyLanguageSettings(language) {
    if (window.i18n && typeof window.i18n.changeLanguage === "function") {
      i18n.changeLanguage(language);
    }
    document.body.className = `language-${language}`;
    updateLanguageDisplay(language);
  }

  document.addEventListener("DOMContentLoaded", () => {
    const language = getNormalizedLanguage();
    applyLanguageSettings(language);

    const languageList = document.querySelectorAll(".i18n-list>li");

    languageList.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const selectedLanguage = item.getAttribute("data-txt");
        applyLanguageSettings(selectedLanguage);
      });
    });

    const iSwitchContainers = document.querySelectorAll(".i18n-switch.mini");
    console.log(iSwitchContainers, "iSwitchContainers");

    // 修正选择器（必做，解决列表无法展开的核心问题）
    document.addEventListener("click", function (e) {
      iSwitchContainers.forEach((container) => {
        const iSwitchList = container.querySelector(".i18n-list");
        if (iSwitchList && !container.contains(e.target)) {
          iSwitchList.classList.remove("active");
        }
      });
    });

    iSwitchContainers.forEach((container) => {
      // 正确获取 i18n-list（移除多余的父级选择器，避免 null）
      const iSwitchList = container.querySelector(".i18n-list");
      const iSwitchItems = container.querySelectorAll(".i18n-list li");
      container.addEventListener("click", function (e) {
        console.log(iSwitchList, "iSwitchList---");
        e.preventDefault();
        e.stopPropagation();
        if (iSwitchList) {
          iSwitchList.classList.toggle("active");
        }
      });

      // 列表项点击事件
      iSwitchItems.forEach((item) => {
        item.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          iSwitchItems.forEach((li) => li.classList.remove("active"));
          this.classList.add("active");

          // 补充：保存语言偏好到 localStorage
          const selectedLang = this.getAttribute("data-txt");
          if (selectedLang) {
            localStorage.setItem("preferred-language", selectedLang);
            applyLanguageSettings(selectedLang);
          }

          if (iSwitchList) {
            iSwitchList.classList.remove("active");
          }
          console.log(iSwitchList);
        });
      });

      if (iSwitchList) {
        iSwitchList.addEventListener("click", function (e) {
          e.stopPropagation();
        });
      }
    });
  });

  /*------------------------返回顶部----------------------------------*/
  function showHeader() {
    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.scrollTop = scrollTop;
  }
  window.addEventListener("scroll", showHeader);

  // left: 37, up: 38, right: 39, down: 40
  var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
  var supportsPassive = false;
  try {
    window.addEventListener(
      "test",
      null,
      Object.defineProperty({}, "passive", {
        get: function () {
          supportsPassive = true;
        },
      })
    );
  } catch (e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent =
    "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  /*-------------------------------导航栏图片加载---------------------------------------*/
  document.querySelector(".logoImage")
    ? (document.querySelector(".logoImage").src = require("@/assets/logo.png"))
    : "";
  document.querySelector(".logo-img")
    ? (document.querySelector(".logo-img").src = require("@/assets/logo.png"))
    : "";
  document.querySelector(".normal .i18n-logo")
    ? (document.querySelector(
        ".normal .i18n-logo"
      ).src = require("@/assets/image/i18n-logo.png"))
    : "";
  document.querySelector(".normal .i18n-arrow")
    ? (document.querySelector(
        ".normal .i18n-arrow"
      ).src = require("@/assets/image/i18n-arrow.png"))
    : "";
  document.querySelector(".mini .i18n-logo")
    ? (document.querySelector(
        ".mini .i18n-logo"
      ).src = require("@/assets/image/i18n-logo.png"))
    : "";
  document.querySelector(".mini .i18n-arrow")
    ? (document.querySelector(
        ".mini .i18n-arrow"
      ).src = require("@/assets/image/i18n-arrow.png"))
    : "";

  // 底部图片加载
  document.querySelector(".footerLeft .logo")
    ? (document.querySelector(
        ".footerLeft .logo"
      ).src = require("@/assets/image/footerLogo.png"))
    : "";
  let midia = [
    {
      imageUrl: require("@/assets/image/footer01.png"),
    },
    {
      imageUrl: require("@/assets/image/footer05.png"),
    },
    {
      imageUrl: require("@/assets/image/footer02.png"),
    },
    {
      imageUrl: require("@/assets/image/footer03.png"),
    },
    {
      imageUrl: require("@/assets/image/footer04.png"),
    },
  ];
  document.querySelectorAll(".footerLeft .channel").forEach((item, idx) => {
    item.src = midia[idx].imageUrl;
  });

  // rem计算 - flexible.js
  (function flexible(window, document) {
    const docEl = document.documentElement;
    const dpr = window.devicePixelRatio || 1;

    // 设置body的字体大小
    function setBodyFontSize() {
      if (document.body) {
        document.body.style.fontSize = 12 * dpr + "px";
      } else {
        document.addEventListener("DOMContentLoaded", setBodyFontSize);
      }
    }
    setBodyFontSize();

    // 设置rem单位
    function setRemUnit() {
      const clientWidth = docEl.clientWidth;
      let rem = clientWidth / 19.2;
      docEl.style.fontSize = rem + "px";
    }
    setRemUnit();

    // 监听窗口变化
    window.addEventListener("resize", setRemUnit);
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) {
        setRemUnit();
      }
    });
  })(window, document);

  document.addEventListener("DOMContentLoaded", function () {
    // 获取所有导航链接和章节
    const navLinks = document.querySelectorAll(".linkNormal");
    const sections = document.querySelectorAll(".section");
    const scrollToTopBtn = document.getElementById("scrollToTop");

    // 平滑滚动函数
    function smoothScroll(targetId) {
      const targetSection = document.getElementById(targetId);
      if (targetSection) {
        window.scrollTo({
          top: targetSection.offsetTop - 80,
          behavior: "smooth",
        });
      }
    }

    // 点击导航链接时的平滑滚动
    navLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const targetId = this.getAttribute("href").substring(1);
        smoothScroll(targetId);

        // 更新活动链接
        navLinks.forEach((link) => link.classList.remove("active-link"));
        this.classList.add("active-link");
      });
    });

    // 改进的滚动检测函数 - 基于视口位置
    function highlightNavOnScroll() {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;

      let closestSection = null;
      let closestDistance = Infinity;

      // 检查每个部分相对于视口的位置
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const sectionId = section.getAttribute("id");

        const sectionTop = rect.top + scrollPosition;
        const sectionBottom = rect.bottom + scrollPosition;

        const visibleTop = Math.max(rect.top, 0);
        const visibleBottom = Math.min(rect.bottom, windowHeight);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);

        const distanceFromTop = rect.top - 80;

        const threshold = windowHeight * 0.3;

        if (
          distanceFromTop < threshold &&
          Math.abs(distanceFromTop) < Math.abs(closestDistance)
        ) {
          closestDistance = distanceFromTop;
          closestSection = sectionId;
        }

        // 特殊情况：如果滚动到页面底部，最后一个部分应该被高亮
        const scrollBottom = scrollPosition + windowHeight;
        const documentHeight = document.documentElement.scrollHeight;

        if (scrollBottom >= documentHeight - 100 && sectionId === "contact") {
          closestSection = "contact";
          console.log("gaoliang-contact", scrollBottom, documentHeight - 100);
        }
      });

      // 高亮对应的导航链接
      navLinks.forEach((link) => {
        link.classList.remove("active-link");
        console.log("gaoliang", closestSection, link.getAttribute("href"));
        if (
          closestSection &&
          link.getAttribute("href").substring(1) === closestSection
        ) {
          link.classList.add("active-link");
        }
      });

      // 如果没有找到合适的高亮部分，默认高亮第一个
      if (!closestSection && scrollPosition < 100) {
        navLinks.forEach((link) => link.classList.remove("active"));
        document.querySelector('a[href="#home"]').classList.add("active");
      }

      // 显示/隐藏返回顶部按钮
      if (scrollPosition > 300) {
        scrollToTopBtn.classList.add("show");
      } else {
        scrollToTopBtn.classList.remove("show");
      }
    }

    // 节流函数，防止滚动事件过于频繁触发
    function throttle(func, delay) {
      let timeout = null;
      return function () {
        if (!timeout) {
          timeout = setTimeout(() => {
            func();
            timeout = null;
          }, delay);
        }
      };
    }

    // 监听滚动事件（使用节流优化性能）
    window.addEventListener("scroll", throttle(highlightNavOnScroll, 100));

    // 返回顶部功能
    scrollToTopBtn.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });

    // 初始化页面时执行一次高亮函数
    highlightNavOnScroll();
  });

  const wechatContainers = document.querySelectorAll(".wechatContainer");
  const qrcodeBoxes = document.querySelectorAll(".qrcode-box");

  let midiaQrcode = [
    {
      imageUrl: require("@/assets/image/midiaQrcode1.jpg"),
    },
    {
      imageUrl: require("@/assets/image/midiaQrcode2.png"),
    },
  ];

  document.querySelectorAll(".qrcode-box .qrcode-img").forEach((item, idx) => {
    item.src = midiaQrcode[idx]?.imageUrl || "";
  });

  let isClickActiveList = new Array(wechatContainers.length).fill(false);

  wechatContainers.forEach((container, idx) => {
    container.addEventListener("click", function (e) {
      console.log("click---");
      e.stopPropagation();

      const qrcodeBox = qrcodeBoxes[idx];
      console.log(qrcodeBoxes, "34234--");
      if (!qrcodeBox) return;

      if (qrcodeBox.style.display === "block") {
        qrcodeBox.style.display = "none";
        isClickActiveList[idx] = false;
      } else {
        qrcodeBoxes.forEach((box) => (box.style.display = "none"));
        isClickActiveList.fill(false);

        qrcodeBox.style.display = "block";
        isClickActiveList[idx] = true;
      }
    });
  });

  document.addEventListener("click", function () {
    isClickActiveList.forEach((isActive, idx) => {
      if (isActive && qrcodeBoxes[idx]) {
        qrcodeBoxes[idx].style.display = "none";
        isClickActiveList[idx] = false;
      }
    });
  });
} else {
  // 重复引入时，仅打印警告，不执行任何核心逻辑
  console.warn("当前JS文件已重复引入，已阻止重复执行");
}

// 第四步：export 语句保留在文件顶层（满足 ESM 语法要求，不可嵌套）
export function enableScroll() {
  const supportsPassive = window.supportsPassive || false;
  const wheelOpt = supportsPassive ? { passive: false } : false;
  const wheelEvent =
    "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

  window.removeEventListener("DOMMouseScroll", preventDefault, false);
  window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
  window.removeEventListener("touchmove", preventDefault, wheelOpt);
  window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
}

export function disableScroll() {
  const supportsPassive = window.supportsPassive || false;
  const wheelOpt = supportsPassive ? { passive: false } : false;
  const wheelEvent =
    "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

  window.addEventListener("DOMMouseScroll", preventDefault, false);
  window.addEventListener(wheelEvent, preventDefault, wheelOpt);
  window.addEventListener("touchmove", preventDefault, wheelOpt);
  window.addEventListener("keydown", preventDefaultForScrollKeys, false);
}

// 补充：全局声明需要的辅助函数（避免 export 内部引用报错）
function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  const keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}
